export default {
  banners: [
    {
      id: 1,
      name: "Banners",
      slug: "banner",
      image: "zenbooka14.jpg",
      alt: "Banner Zenbook A 14",
    },
    {
      id: 1,
      name: "Banners",
      slug: "banner",
      image: "banner_z_flip.jpg",
      alt: "Banner Asus Zenbook 13 Flip OLED",
    },
    {
      id: 7,
      name: "Banner Asus K513",
      slug: "banner",
      image: "banner6.jpg",
      alt: "Fotos de Trabalhos Desenvolvidos Cliente Asus",
    },
    {
      id: 2,
      name: "Banners",
      slug: "banner",
      image: "banner2.jpg",
      alt: "Fotos de Trabalhos Desenvolvidos",
    },
    {
      id: 3,
      name: "Banners",
      slug: "banner",
      image: "banner3.jpg",
      alt: "Fotos de Trabalhos Desenvolvidos",
    },
    {
      id: 4,
      name: "Banners",
      slug: "banner",
      image: "vivobook6.jpg",
      alt: "Vivobook com IA",
    },
  ],

  frontend: [
    {
      id: 55,
      title: "Javascript",
      image: "javascript.png",
      alt: "Javascript",
    },
    {
      id: 56,
      title: "HTML 5",
      image: "html5.png",
      alt: "HTML 5",
    },
    {
      id: 57,
      title: "CSS 3",
      image: "css.png",
      alt: "CSS 3",
    },
  ],

  ux: [
    {
      id: 58,
      title: "Axure",
      image: "axure.png",
      alt: "Axure",
    },
    {
      id: 59,
      title: "Figma",
      image: "figma.png",
      alt: "Figma",
    },
  ],

  ui: [
    {
      id: 60,
      title: "Photoshop",
      image: "photoshop.jpg",
      alt: "Photoshop",
    },
    {
      id: 61,
      title: "Ilustrator",
      image: "ilustrator.jpg",
      alt: "Ilustrator",
    },
  ],

  database: [
    {
      id: 62,
      title: "Mysql",
      image: "mysql.png",
      alt: "Mysql",
    },
    {
      id: 63,
      title: "Firebase",
      image: "firebase.png",
      alt: "Firebase",
    },
  ],

  frameworks: [
    {
      id: 62,
      title: "Vue JS",
      image: "vue.png",
      alt: "Vue JS",
    },
    {
      id: 63,
      title: "Next JS",
      image: "next.png",
      alt: "Next JS",
    },
    {
      id: 64,
      title: "Nuxt JS",
      image: "nuxt.png",
      alt: "Nuxt JS",
    },
    {
      id: 78,
      title: "Quasar",
      image: "quasar.png",
      alt: "Framework Quasar",
    },
    {
      id: 65,
      title: "Astro JS",
      image: "astro.png",
      alt: "Astro JS",
    },
    {
      id: 69,
      title: "Bootstrap",
      image: "bootstrap.png",
      alt: "Bootstrap",
    },
    {
      id: 70,
      title: "Sass",
      image: "sass.png",
      alt: "Sass",
    },
    {
      id: 90,
      title: "Tailwind CSS",
      image: "tailwind_logo.png",
      alt: "Tailwind CSS",
    },
    {
      id: 91,
      title: "HTMX",
      image: "htmx.png",
      alt: "HTMX",
    },
  ],

  otimizadores: [
    {
      id: 66,
      title: "Gulp",
      image: "gulp.png",
      alt: "Gulp",
    },
    {
      id: 67,
      title: "Webpack",
      image: "webpack.png",
      alt: "Webpack",
    },
    {
      id: 68,
      title: "Grunt",
      image: "grunt.png",
      alt: "Grunt",
    },
  ],

  experiencias: [
    {
      id: 1,
      title: "Diversidade",
      description:
        "com o avanço de novas tecnologias , busco manter-se atualizado as novas tecnoligias, para prestar o melhor trabalho para o cliente final, tanto com desenvolvimento front-end , quanto com UX/UI",
    },
    {
      id: 2,
      title: "Experiência",
      description:
        "18 anos de experiência em desenvolvimento front-end, aplicando as melhores práticas e ajudando clientes a obterem os melhores resultados para sua empresa.",
    },
    {
      id: 3,
      title: "Freelancer",
      description:
        "Vasta Experiência em trabalhos Freelancer, em parceria com agências de grande porte no mercado e , clientes informais.",
    },
  ],

  projetos: [
    {
      id: 97,
      desc: "CV Online Versão 2 - Detalhes",
      img: "cvv2.jpg",
      name: "CV Online Versão 2 - Detalhes",
      category: "recentes",
      url: "http://www.wagneramos.com.br/CVV2",
      title: "Visitar CV",
    },
    {
      id: 92,
      desc: "Asus Zenbook A14",
      img: "zenbook-a14.jpg",
      name: "Asus Zenbook A14",
      category: "recentes",
    },

    {
      id: 1,
      desc: "clube de golf Vista Verde",
      img: "club-golf-vilaverde.jpg",
      name: "Vista Verde",
      category: "mais antigos",
    },
    {
      id: 2,
      desc: " Desenvolvimeto Portal Mundo Tim - 2015",
      img: "mundo-tim.jpg",
      name: "Mundo Tim",
      category: "mais  antigos",
    },
    {
      id: 4,
      desc: " Hot Site Comemorativo dias dos Pais  - 2016",
      img: "pais.jpg",
      name: "Dia dos Pais Estadão",
      category: "mais antigos",
    },
    {
      id: 5,
      desc: "Campanha Gentileza Gera Sobremesa Fifties ",
      img: "gentileza.jpg",
      name: "Gentileza Gera Sobremesa",
      category: "mais antigos",
    },
    {
      id: 6,
      desc: "Hot Site Chuteira Umbro Diamond",
      img: "diamond.jpg",
      name: "Umbro Diamond",
      category: "mais antigos",
    },
    {
      id: 7,
      desc: "Hot Site Camisa Umbro Club de Regatas Vasco da Gama",
      img: "vasco.jpg",
      name: "Umbro Camisa Vasco",
      category: "mais antigos",
    },
    {
      id: 8,
      desc: "Hot Site Camisa Umbro Clube Náutivo Capibaribe",
      img: "nautico.jpg",
      name: "Umbro Camisa Náutico",
      category: "mais antigos",
    },
    {
      id: 9,
      desc: "Hot Site Chuteira Falcão Pro Black & white",
      img: "falcao.jpg",
      name: "Umbro Chuteira Falcão Náutico",
      category: "mais antigos",
    },
    {
      id: 10,
      desc: "Blog Sanitrit",
      img: "blog-sanitrit.jpg",
      name: "Blog Sanitrit By Agência Caule",
      category: "mais antigos",
    },
    {
      id: 11,
      desc: "Dans Restaurante",
      img: "dans.jpg",
      name: "Dans Restaurante e Requinte",
      category: "mais antigos",
    },
    {
      id: 12,
      desc: "Grand Brasil",
      img: "grand-brasil.jpg",
      name: "Grand Brasil Autos",
      category: "mais antigos",
    },
    {
      id: 13,
      desc: "Restaurante Mexicano Si Senõr",
      img: "sisenor.jpg",
      name: "Restaurante Mexicano Si Senõr",
      category: "mais antigos",
    },
    {
      id: 14,
      desc: "Olea Mozzarella Bar",
      img: "olea.jpg",
      name: "Olea Mozzarella Bar",
      category: "mais antigos",
    },
    {
      id: 15,
      desc: "Tintas Lukscolor - 2012",
      img: "lukscolor.jpg",
      name: "Tintas Lukscolor",
      category: "mais antigos",
    },
    {
      id: 17,
      desc: "Residencial Sítios das Hortênsias",
      img: "hortencias.jpg",
      name: "Residencial Sítios das Hortênsias",
      category: "mais antigos",
    },
    {
      id: 18,
      desc: "NoteBook Asus VivoBook Max - Modelo X541NA",
      img: "asus-vivobook-x541na.jpg",
      name: "Asus VivoBook Max",
      category: "mais antigos",
    },
    {
      id: 19,
      desc: "Telefone  Asus Zenfone Live - Modelo ZB501KL",
      img: "asus-zenfone-live-zb501kl.jpg",
      name: "Asus Zenfone Live",
      category: "mais antigos",
    },
    {
      id: 20,
      desc: "Hotsite  Asus Kalunga",
      img: "kalunga.jpg",
      name: "Asus Kalunga Online",
      category: "mais antigos",
    },
    {
      id: 21,
      desc: "Hotsite  Produstos Asus Fnac",
      img: "asus-fnac.jpg",
      name: "Asus Fnac Online",
      category: "mais antigos",
    },
    {
      id: 22,
      desc: "Asus Zenfone 4",
      img: "asus-zenfone4.jpg",
      name: "Asus Zenfone 4",
      category: "mais antigos",
    },
    {
      id: 23,
      desc: "Site Artista Fernando Santos",
      img: "site-fernando-santos.jpg",
      name: "Site Fernando Santos",
      category: "mais antigos",
    },
    {
      id: 24,
      desc: "Asus VivoBook Modelo X510UA",
      img: "asus-vivobook-x510ua.jpg",
      name: "VivoBook Asus",
      category: "mais antigos",
    },

    {
      id: 26,
      desc: "Asus ZenBook 3 Deluxe",
      img: "zenbook3-deluxe.jpg",
      name: "Asus Zenbook 3 Deluxe",
      category: "mais antigos",
    },
    {
      id: 27,
      desc: "Asus ZenFone 5 Selfie",
      img: "asus-zenfone5-selfie.jpg",
      name: "Asus ZenFone 5 Selfie",
      category: "mais antigos",
    },
    {
      id: 28,
      desc: " Asus Zenfone Zoom S",
      img: "asus-zenfone-zooms.jpg",
      name: "Asus Zenfone  Zoom S",
      category: "mais antigos",
    },
    {
      id: 29,
      desc: " Asus Zenfone 5 Z",
      img: "asus-zenfone-5.jpg",
      name: "Asus Zenfone 5 Z ",
      category: "mais antigos",
    },
    {
      id: 30,
      desc: " Asus ZenBook  - Modelo UX410UX",
      img: "asus-zenbook-ux410ua.jpg",
      name: "Asus ZenBook ",
      category: "mais antigos",
    },
    {
      id: 31,
      desc: " Asus ZenFone 4 Selfie",
      img: "asus-zenfone-4-selfie.jpg",
      name: "Asus ZenFone 4 Selfie",
      category: "mais antigos",
    },
    {
      id: 32,
      desc: " Asus Câmera 360",
      img: "asus-camera-360.jpg",
      name: "Asus Câmera 360",
      category: "mais antigos",
    },
    {
      id: 33,
      desc: "Asus ZenWatch 2",
      img: "asus-watch-2.jpg",
      name: "Asus ZenWatch 2",
      category: "mais antigos",
    },
    {
      id: 34,
      desc: "Asus ZenWatch 3",
      img: "asus-watch-3.jpg",
      name: "Asus ZenWatch 3",
      category: "mais antigos",
    },

    {
      id: 82,
      desc:
        "Desenvolvido com NUXT JS Multi Languages (Português, Inglês, Espanhol e Alemão)",
      img: "cvonline.jpg",
      name: "CV Online",
      url: "http://www.wagneramos.com.br/clientes/cvonline",
      title: "Visitar Projeto",
      category: "recentes",
    },

    {
      id: 93,
      desc: "Asus Vivobook S14",
      img: "vivobooks14.jpg",
      name: "Asus Vivobook  S14",
      category: "recentes",
    },

    {
      id: 94,
      desc: "Asus TUF A15",
      img: "asus-tufa15.png",
      name: "Asus TUF A15",
      category: "recentes",
    },

    {
      id: 95,
      desc: "Asus Vivobook A16",
      img: "asus-vivobooka16.png",
      name: "Asus Vivobook A16",
      category: "recentes",
    },

    {
      id: 87,
      desc: "Asus Rog Flow",
      img: "flow.jpg",
      name: "Asus Rog Flow",
      category: "recentes",
    },

    {
      id: 96,
      desc: "Asus Rog Zephyrus G16",
      img: "zephyrus.jpg",
      name: "Asus Zephyrus",
      category: "recentes",
    },

    {
      id: 88,
      desc: "Asus Rog Strix G16",
      img: "strix.jpg",
      name: "Asus Rog Strix",
      category: "recentes",
    },

    {
      id: 89,
      desc: "Asus TUF Gaming A16",
      img: "tuf16.jpg",
      name: "Asus TUF",
      category: "recentes",
    },

    {
      id: 90,
      desc: "Asus TUF Gaming F15",
      img: "tuf15.jpg",
      name: "Asus TUF",
      category: "recentes",
    },

    {
      id: 83,
      desc: "Asus Vivobook 15X OLED",
      img: "vivo_15.jpg",
      name: "Vivobook 15X OLED",
      category: "recentes",
    },

    {
      id: 80,
      desc: "Asus Fold OLED",
      img: "ux9702.jpg",
      name: "Asus Fold OLED",
      category: "recentes",
    },
    {
      id: 84,
      desc: "Asus Zenfone 10",
      img: "zenfone10.jpg",
      name: "Asus Zenfone 10",
      category: "recentes",
    },

    {
      id: 85,
      desc: "Asus Vivobook Go 15",
      img: "vivobook_go.png",
      name: "Asus Vivobook Go 15",
      category: "recentes",
    },

    {
      id: 86,
      desc: "Asus Zenbook S13 Flip OLED",
      img: "z_flip.jpg",
      name: "Asus Zenbook S13 Flip OLED",
      category: "recentes",
    },

    {
      id: 79,
      desc: "Asus Zenfone 9",
      img: "zenfone9.jpg",
      name: "Asus Zenfone 9",
      category: "recentes",
    },

    {
      id: 78,
      desc: "Asus TUF Gaming F15",
      img: "asus_tuf.jpg",
      name: "Asus TUF Gaming F15",
      category: "recentes",
    },
    {
      id: 81,
      desc: "Asus VivoBook 15",
      img: "vivobook_15.jpg",
      name: "Asus VivoBook 15",
      category: "recentes",
    },

    {
      id: 77,
      desc: "Desenvolvido com Vue js + API Rest ",
      img: "employe.jpg",
      name: "CRUD Add Employer",
      url: "http://www.wagneramos.com.br/clientes/employe_list",
      title: "Visitar Projeto",
      category: "recentes",
    },

    {
      id: 76,
      desc: "Desenvolvido com Vue js + Api Rest ",
      img: "busca_github.jpg",
      name: "Search Repositories Github",
      url: "http://www.wagneramos.com.br/clientes/api_github",
      title: "Visitar Projeto",
      category: "recentes",
    },

    {
      id: 75,
      desc: "Desenvolvido com Vue js + Api Rest ",
      img: "stock_trade.jpg",
      name: "Project Stock Trade",
      url: "http://www.wagneramos.com.br/clientes/stock",
      title: "Visitar Projeto",
      category: "recentes",
    },

    {
      id: 74,
      desc: "Desenvolvido com Vue js ",
      img: "quotes.jpg",
      name: "Project Magical Quotes",
      url: "http://www.wagneramos.com.br/clientes/quotes",
      title: "Visitar Projeto",
      category: "recentes",
    },

    {
      id: 73,
      desc: "Desenvolvido com Vue js + Vue X ",
      img: "cart_vue.jpg",
      name: "Mini Shop Cart",
      url: "http://www.wagneramos.com.br/clientes/cart",
      title: "Visitar Projeto",
      category: "recentes",
    },

    {
      id: 71,
      desc: "Desenvolvido com Vue js",
      img: "infos_travel.jpg",
      name: "Hot Site Infos Travel",
      url: "http://www.wagneramos.com.br/travel",
      title: "Visitar Projeto",
      category: "recentes",
    },

    {
      id: 62,
      desc: "Asus VivoBook K513",
      img: "asus-k513.jpg",
      name: "Site Asus VivoBook K513",
      category: "recentes",
      url: "http://www.wagneramos.com.br/clientes/k513",
      title: "Visitar Projeto",
    },
    {
      id: 63,
      desc: "Site Rog G731",
      img: "asus-G731.jpg",
      name: "Site Asus ROG G731  ",
      category: "recentes",
      url: "http://www.wagneramos.com.br/clientes/g731",
      title: "Visitar Projeto",
    },
    {
      id: 60,
      desc: " Asus UX 482",
      img: "asus-ux482.jpg",
      name: "Site Asus UX482  ",
      category: "recentes",
    },

    {
      id: 35,
      desc: "Site Rog GX 1000",
      img: "mouse_rog_gx1000.jpg",
      name: "Site Mouse Rog GX 1000",
      category: "recentes",
    },

    {
      id: 36,
      desc: "Site Zephyrus G14",
      img: "zephyrusg14.jpg",
      name: "Site Zephyrus G14",
      category: "recentes",
    },

    {
      id: 37,
      desc: "Site Zephyrus Duo 15",
      img: "zephyrus_duo15.jpg",
      name: "Site Zephyrus Duo 15",
      category: "recentes",
    },

    {
      id: 38,
      desc: "Site Notebook X571GT",
      img: "x571gt.jpg",
      name: "Site Notebook X571GT",
      category: "mais antigos",
    },

    {
      id: 39,
      desc: "Site Rog Strix Core",
      img: "teclado_rog_strix.jpg",
      name: "Site Teclado Rog Strix Core",
      category: "recentes",
    },

    {
      id: 40,
      desc: "Site Rog Phone 3",
      img: "rogphone3.jpg",
      name: "Site Rog Phone 3",
      category: "recentes",
    },

    {
      id: 41,
      desc: "Site Rog Cetra Core",
      img: "rog_cetra_core.jpg",
      name: "Site Phone Rog Cetra Core",
      category: "recentes",
    },

    {
      id: 42,
      desc: "Asus ZenBook Pro 15 - Modelo UX580",
      img: "asus-ux580.jpg",
      name: "Asus ZenBook Pro 15",
      category: "recentes",
    },

    {
      id: 43,
      desc: "Asus VivoBook - Modelo X512",
      img: "asus-vivobook-x512.jpg",
      name: "Asus VivoBook X512",
      category: "mais antigos",
    },
    {
      id: 44,
      desc: "Asus Notebook - Modelo X543",
      img: "asus-x543.jpg",
      name: "Asus Notebook X543",
      category: "mais antigos",
    },
    {
      id: 45,
      desc: "Asus ZenBook  - Modelo UX433",
      img: "asus-ux433.jpg",
      name: "Asus ZenBook 14 - Ux433",
      category: "recentes",
    },
    {
      id: 46,
      desc: "Asus ZenBook  - Modelo UX581",
      img: "asus-ux581.jpg",
      name: "Asus ZenBook 15",
      category: "recentes",
    },
    {
      id: 47,
      desc: "Asus ZenBook  - Modelo UX434",
      img: "asus-zenbook-ux434.jpg",
      name: "Asus ZenBook 14 - UX434",
      category: "recentes",
    },
    {
      id: 48,
      desc: "Asus ZenFone Live  - Modelo L2",
      img: "asus-zenfone-live-l2.jpg",
      name: "Asus ZenFone Live",
      category: "mais antigos",
    },
    {
      id: 49,
      desc: "Asus ZenFone 6 30 Edition",
      img: "asus-zenfone-6-30-edition.jpg",
      name: "Asus ZenFone 6 30 Edition",
      category: "recentes",
    },

    {
      id: 50,
      desc: "Asus RogPhone 2 - Game Changer",
      img: "asus-rogphone-2.jpg",
      name: "Asus RogPhone 2",
      category: "recentes",
    },
    {
      id: 51,
      desc: "Asus Duo - Modelo UX 481",
      img: "asus-ux481-duo.jpg",
      name: "Asus Duo",
      category: "recentes",
    },
    {
      id: 52,
      desc: "Asus Zenbook - Modelo UX 431",
      img: "asus-ux431.jpg",
      name: "Asus Zenbook",
      category: "recentes",
    },
    {
      id: 53,
      desc: "Asus Zephirus",
      img: "asus-zephirus.jpg",
      name: "Asus Zephirus",
      category: "recentes",
    },

    {
      id: 54,
      desc: "Site Lexus",
      img: "lexus.jpg",
      name: "Site Lexus",
      category: "recentes",
    },
    {
      id: 55,
      desc: "Site Hub - Rental Office Furniture",
      img: "hub.jpg",
      name: "Site Hub",
      category: "recentes",
    },
    {
      id: 56,
      desc: "Site 4takes ",
      img: "4takes.jpg",
      name: "Site 4Takes",
      category: "recentes",
    },
    {
      id: 57,
      desc: "Sistema interno de Vendas BMW Select",
      img: "bmw-select.jpg",
      name: "BMW Select",
      category: "mais antigos",
    },
    {
      id: 58,
      desc: "Site Top Brands",
      img: "topbrands.jpg",
      name: "Top Brands",
      category: "mais antigos",
    },
    {
      id: 59,
      desc: "Site Business Monster",
      img: "bm.jpg",
      name: "Site  Business Monster",
      category: "mais antigos",
    },
  ],
};
